import type React from "react";
import type { DashProgressBarProps } from "./DashProgressBar.model";
import { StyledProgressBar, StyledProgressItem } from "./DashProgressBar.styled";

export const DashProgressBar: React.FC<DashProgressBarProps> = ({ progress }) => (
  <StyledProgressBar>
    <StyledProgressItem progress={progress} />
    <StyledProgressItem progress={progress} />
    <StyledProgressItem progress={progress} />
    <StyledProgressItem progress={progress} />
    <StyledProgressItem progress={progress} />
  </StyledProgressBar>
);

export default DashProgressBar;
